"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Download() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 37 32"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(.2 .3) translate(1 1)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 21.078a1 1 0 00-1 1V25c0 2.954 2.456 5.242 5.498 5.242h25.703c3.037 0 5.498-2.286 5.498-5.242v-2.922a1 1 0 00-1-1 1 1 0 00-1 1V25c0 1.892-1.407 3.242-3.498 3.242H4.498C2.399 28.242 1 26.894 1 25v-2.922a1 1 0 00-1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.992-1a1 1 0 00-1 1v21.969a1 1 0 001 1 1 1 0 001-1V0a1 1 0 00-1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.096 10.06a1 1 0 00-.735.294 1 1 0 000 1.414l10.924 10.91a1 1 0 001.414 0l10.924-10.91a1 1 0 000-1.414 1 1 0 00-1.414 0L17.992 20.557 7.775 10.354a1 1 0 00-.68-.293z"
  })));
}

var _default = Download;
exports.default = _default;